<template>
  <layout>
    <div class="text-xs-center">
      <page-title v-if="state === 'initial' || state === 'processing'" />
      <page-title class="mt-5" subheader="Algo errado. Verifique o link" v-if="state === 'error'" />
    </div>
    <v-tooltip bottom nudge-bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon x-large
          v-bind="attrs"
          v-on="on"
          icon @click="logoClick()"
          class="arrow-back-icon pt-10">keyboard_arrow_left
        </v-icon>
      </template>
      <span>{{ i18n('Voltar para o login') }}</span>
    </v-tooltip>
    <div class="mx-auto dark-color" style="width: 370px; margin-top: -5%;">
      <div class=" mx-auto mt-20 flex justify-center" style="width: 370px">
        <img :src="logoPath()" />
      </div>
      <v-form class="mt-20 dark-color" v-model="form_valid" ref="form">
        <h3 class="mt-3 mb-3"> {{ i18n ('Definir Senha')}}</h3>
        <h4>{{i18n('Defina a sua senha nos campos abaixo')}}.</h4><br>
        <div v-if="state === 'error'" class="error-message red--text mt-2">
          {{ i18n('Algo errado. Não foi possível verificar o link.') }}
        </div>
        <v-flex>
          <v-text-field
            outline
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            color="secondary-button-background-color"
            background-color="input-color"
            :label="i18n('Senha')"
            :rules="passwordConfirmationRules"
            :errorMessages="passwordErrorMessages"
            @keyup="passwordFieldChanged"
            @keyup.enter="setPassword()">
            <template slot="append">
              <v-icon @click="showPassword = !showPassword" style="cursor: pointer" color="black">
                {{ showPassword ? 'visibility' : 'visibility_off' }}
              </v-icon>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            outline
            v-model="password_confirmation"
            color="secondary-button-background-color"
            background-color="input-color"
            :label="i18n('Repita senha')"
            :rules="passwordConfirmationRules"
            :errorMessages="passwordConfirmationErrorMessages"
            :type="showPasswordRepeat ? 'text' : 'password'"
            @keyup.enter="setPassword()">
            <template slot="append">
              <v-icon @click="showPasswordRepeat = !showPasswordRepeat" style="cursor: pointer" color="black">
                {{ showPasswordRepeat ? 'visibility' : 'visibility_off' }}
              </v-icon>
            </template>
          </v-text-field>
        </v-flex>
        <v-card color="#03121C" tile outlined class="pa-4 text-left">
          <h4 class="mb-4 white--text">{{ i18n('Regras para nova senha') }}</h4>
          <div>
            <div :class="['rule-item', ruleClass(isMinimumLengthValid)]">
              <v-icon small class="mr-2">{{ icon(isMinimumLengthValid) }}</v-icon>
              {{ i18n('Mínimo de 12 caracteres') }}
            </div>
            <div :class="['rule-item', ruleClass(isMaximumLengthValid)]">
              <v-icon small class="mr-2">{{ icon(isMaximumLengthValid) }}</v-icon>
              {{ i18n('Máximo de 64 caracteres') }}
            </div>
            <div :class="['rule-item', ruleClass(hasUppercase)]">
              <v-icon small class="mr-2">{{ icon(hasUppercase) }}</v-icon>
              {{ i18n('Pelo menos uma letra maiúscula') }}
            </div>
            <div :class="['rule-item', ruleClass(hasLowercase)]">
              <v-icon small class="mr-2">{{ icon(hasLowercase) }}</v-icon>
              {{ i18n('Pelo menos uma letra minúscula') }}
            </div>
            <div :class="['rule-item', ruleClass(hasNumber)]">
              <v-icon small class="mr-2">{{ icon(hasNumber) }}</v-icon>
              {{ i18n('Pelo menos um número') }}
            </div>
            <div :class="['rule-item', ruleClass(hasSpecialChar)]">
              <v-icon small class="mr-2">{{ icon(hasSpecialChar) }}</v-icon>
              {{ i18n('Pelo menos um caractere especial !, @, #, etc.') }}
            </div>
          </div>
        </v-card>
        <v-btn class="sign-btn" block large :disabled="!isPasswordValid" @click="setPassword()">
          <div class="flex-inline-center">
            <h3 class="font-bold text-lg">{{ i18n('Definir Senha') }}</h3>
          </div>
        </v-btn>
      </v-form>
    </div>
  </layout>
</template>


<script>
import LoginLayout from "./layouts/LoginLayout"
import Title from "./components/Title"

export default {
  name: 'SetPassword',
  components: { layout: LoginLayout, 'page-title': Title },
  data: () => {
    return {
      password: '',
      password_confirmation: '',
      form_valid: false,
      passwordErrorMessages: [],
      passwordConfirmationErrorMessages: [],
      state: 'initial',
      showPassword: false,
      showPasswordConfirmation: false,
      showPasswordRepeat: false,
      showPasswordConfirmationRepeat: false,
    }
  },
  computed: {
    isPasswordValid() {
      return (
        this.isMinimumLengthValid &&
        this.isMaximumLengthValid &&
        this.hasUppercase &&
        this.hasLowercase &&
        this.hasNumber &&
        this.hasSpecialChar &&
        this.hasNoLeadingOrTrailingSpaces &&
        this.hasNoCedilla &&
        this.password === this.password_confirmation
      )
    },
    isMinimumLengthValid() {
      return this.password.length >= 12
    },
    isMaximumLengthValid() {
      return this.password.length > 0 && this.password.length <= 64
    },
    hasUppercase() {
      return /[A-Z]/.test(this.password)
    },
    hasLowercase() {
      return /[a-z]/.test(this.password)
    },
    hasNumber() {
      return /\d/.test(this.password)
    },
    hasSpecialChar() {
      const password = this.password

      const specialCharsRegex = /[!@#$%^&*(),.?":{}|<>_\-+=~`\\[\];'/]/
      const hasSpecial = specialCharsRegex.test(password)

      const hasMiddleSpace = /\S\s+\S/.test(password)

      return hasSpecial || hasMiddleSpace
    },
    passwordConfirmationRules() {
      return [
        v => (v || '').length > 0 || this.i18n('Campo obrigatório'),
        v => v === this.password || this.i18n('Confirmação da senha não confere')
      ]
    },
    hasNoLeadingOrTrailingSpaces() {
      return this.password === this.password.trim()
    },
    hasNoCedilla() {
      return !/[çÇ]/.test(this.password)
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    logoPath() {
      if (this.$root.getEnvironment() === 'prod') return 'static/logo.svg'
      return 'static/logo-dev.svg'
    },
    logoClick() {
      if (this.signedIn) {
        this.$router.push('/dashboard')
      } else {
        this.$router.push('/')
      }
    },
    passwordFieldChanged() {
      const password = this.password || ''
      const hasSpaces = password !== password.trim()
      const hasCedilla = /[çÇ]/.test(password)

      const errors = []

      if (hasSpaces) {
        errors.push(this.i18n('A senha não pode começar ou terminar com espaços em branco'))
      }

      if (hasCedilla) {
        errors.push(this.i18n('A senha não pode conter o caractere Ç ou ç'))
      }

      this.passwordErrorMessages = errors
    },
    setPassword() {
      this.state = 'initial'
      this.passwordFieldChanged()
      this.passwordConfirmationErrorMessages = []

      if (this.passwordErrorMessages.length > 0) return

      this.$refs.form.validate()
      if (this.state !== 'initial') return
      if (!this.form_valid) return

      if (this.password !== this.password_confirmation) {
        console.log(this.password)
        console.log(this.password_confirmation)
        this.passwordConfirmationErrorMessages = [
          this.i18n('Confirmação da senha não confere')
        ]
        return
      }

      this.state = 'processing'

      const payload = {
        id: this.$route.params.user_id,
        code: this.$route.params.confirmation_code,
        password: this.password
      }

      let successCallback = (response) => {
        if (response.body.data == 'ok') {
          this.$router.push('/sign_in')
        } else {
          if (response.body.error) {
            this.state = 'error'
          }
        }
      }

      let errorCallback = (response) => {
        this.state = 'error'
        console.log(response)
      }

      this.$http.post(this.$root.urls.reset_password, payload).then(successCallback, errorCallback)
    },
    icon(condition) {
      return condition ? 'check_circle' : 'cancel'
    },
    ruleClass(condition) {
      if (!this.password.length) return 'neutral-rule'
      return condition ? 'valid-rule' : 'invalid-rule'
    }
  },
  mounted() {
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style scoped>
.form-color-input >>> .input-color {
  background-color: #0C2E4A !important;
}

.pt-10 {
  padding: 2.5rem !important;
}

.mt-20 {
  margin-top: 5rem;
}

.flex {
  display: flex;
}

.flex-inline-center {
  display: inline-flex;
  flex: 1;
  justify-content: center;
}

/* Vue defaults to white, so we'll be using this class to force the dark color */
.dark-color {
  color: var(--primary-dark-font-color) !important;
}

.justify-center{
  justify-content: center;
}

.bg-primary-color {
  background-color: #06233B !important
}

.sign-btn {
  padding: 30px;
  background-color: #27DABC !important;
}

.sign-btn:hover {
  opacity: 0.80;
}

.arrow-back-icon {
  width: 50px;
  margin-left: 30px;
  display: flex;
  align-items: end;
  justify-content: flex-start;
  color: var(--primary-dark-font-color) !important;
}

.arrow-back-icon:hover {
  cursor: pointer;
  color: #27DABC !important;
}

.v-text-field .v-input__slot {
  border: 1.5px solid #282C2B !important;
  color: var(--primary-dark-font-color) !important;
  border-radius: 4px;
}

.dark-color >>> .v-label,
.dark-color >>> .v-label.v-label--active {
  color: var(--primary-dark-font-color) !important;
}

.dark-color >>> .v-input__slot input {
  color: var(--primary-dark-font-color) !important;
}
.dark-color >>> .v-text-field .v-input__slot {
  border: 1.5px solid #282C2B !important;
  border-radius: 4px;
}

.dark-color >>> .v-input.error--text .v-input__slot,
.dark-color >>> .v-text-field.error--text .v-input__slot {
  border-color: #FF5252 !important;
}

.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}

.mt-5 {
  margin: 1.25rem !important;
}

.rule-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
}

.valid-rule {
  color: #27DABC !important;
}

.invalid-rule {
  color: #F44336 !important;
}

.neutral-rule {
  color: #ffffff99;
}

.sign-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/SetPassword.vue